import { render, staticRenderFns } from "./UpdateUserDataAddressModal.vue?vue&type=template&id=60ad222f&"
import script from "./UpdateUserDataAddressModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserDataAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports